module.exports = __webpack_public_path__ + "static/media/image-money-stack.fe05dfa4.png";